<template>
<div>
    <button  v-if="btn" @click="printPreviewReceipt(props)"  class="btn btn-light float-right">
      <i style="color:black" class="fas fa-print mr-2" aria-hidden="true"></i>
      STAMPA PRECONTO    
    </button>
</div>
</template>
<script>


import PreviewReceipt      from '@/components/mixins/PreviewReceipt.js'
import receiptHeader       from '@/components/mixins/ReceiptHeading.js'

export default {
   mixins  : [PreviewReceipt,receiptHeader],
   props   : ['props'],

}
</script>


